import React, { useCallback } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { ButtonAction } from '@fastlessjs/backoffice-layer/dist/components/atoms';
import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';

import { t } from '../../config/translations';
import { OrderLine } from '../../orders/types';
import { ReturnInfos, ReturnLine } from '../types';

// Register this component for debug tracking
debug.registerComponent('DeleteReturnLine');

type DeleteReturnLineProps = {
  onDeleteReturn: (recordId: { clientId: string; orderId: string; nart: string }) => void;
  record: OrderLine & ReturnLine & ReturnInfos;
};

export const DeleteReturnLine = (props: DeleteReturnLineProps) => {
  debug.trackRender('DeleteReturnLine');
  const { onDeleteReturn, record } = props;

  const handleDelete = useCallback(() => {
    debug.log('DeleteReturnLine', `Deleting return for nart: ${record?.nart}`);
    onDeleteReturn({
      clientId: record.clientId,
      orderId: record.orderId,
      nart: record.nart,
    });
  }, [onDeleteReturn, record]);

  return (
    <ButtonAction
      title={t('button.deleteReturn')}
      icon={<DeleteOutlined style={{ color: 'red' }} />}
      onClick={handleDelete}
    />
  );
};

// Mark this component as initialized
debug.markInitialized('DeleteReturnLine');
